import { useState, useEffect } from "react";

const ONE_SECOND = 1000;

export default function useTimer(seconds: number) {
  const [time, setTime] = useState(seconds);

  // reset timer and optionally change the start time
  function restartTimer(newSeconds = seconds) {
    setTime(newSeconds);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (time > 0) {
        setTime((prev) => prev - 1);
      }
    }, ONE_SECOND);

    return () => clearInterval(interval);
  }, [time]);

  return { time, restartTimer };
}
